module.exports = __webpack_public_path__ + "static/media/Artboard2.f8b843f9.png";